<div class="row">
	<div class="col-lg-12">
		<ol class="breadcrumb">
			<li><a href="javascript:void(0)" (click)="$state.go('missioncontrol.dashboard', {}, {reload: true})">Home</a></li>
			<li class="active"><span>Requisitions</span></li>
		</ol>
		<h1 *ngIf="requisitionsContainer.busy">Requisitions (<span class="skeleton-loading requisitions-count-skeleton"></span>)</h1>
		<h1 *ngIf="!requisitionsContainer.busy">Requisitions ({{requisitionsContainer.requisitionCount}})</h1>
	</div>
</div>
<div class="row">
	<div class="col-xs-12">
		<div *ngIf="isStaffingCompany" class="pull-left requisition-visibility-filters-container">
			<div style="padding-right:10px;" class="pull-left">
				<input type="checkbox" id="isAssignedToMe" name="isAssignedToMe"
					[(ngModel)]="requisitionsContainer.requisitionsQueryFilter.isAssignedToMe" (click)="onGlobalFilterChange()">
				<label for="isAssignedToMe"><strong>Assigned To Me</strong></label>
			</div>
			<div style="padding-right:10px;" class="pull-left">
				<input type="checkbox" id="isAssignedToOthers" name="isAssignedToOthers"
					[(ngModel)]="requisitionsContainer.requisitionsQueryFilter.isAssignedToOthers" (click)="onGlobalFilterChange()">
				<label for="isAssignedToOthers"><strong>Assigned To Others (Shared Only)</strong></label>
			</div>
			<div class="pull-left">
				<input type="checkbox" id="isUnassigned" name="isUnassigned"
					[(ngModel)]="requisitionsContainer.requisitionsQueryFilter.isUnassigned" (click)="onGlobalFilterChange()">
				<label for="isUnassigned"><strong>Unassigned (Shared Only)</strong></label>
			</div>
		</div>

		<div class="pull-right filter-symbol-div-margin">
			<span class="pull-right filter-icon" (click)="toggleFiltersPanel()">
				<i class="fa fa-filter fa-2x cursor-point" aria-hidden="true" id="open-filter"></i>
			</span>
		</div>
		<div class="pull-right filter-symbol-div-margin pull-right">
			<span *ngIf="!requisitionsContainer.busy" (click)="toggleRequisitionRowView()">
				<span title="Switch to card view" class="fa fa-th-large fa-2x cursor-pointer" *ngIf="isRowViewActive"></span>
				<span title="Switch to row view" class="fa fa-th-list fa-2x cursor-pointer" *ngIf="!isRowViewActive"></span>
			</span>
			<span *ngIf="requisitionsContainer.busy" class="skeleton-loading requisitions-view-toggle-skeleton"></span>
		</div>
		<div class="pull-right filter-symbol-div-margin">
			<input type="text" id="requisitionsSearchText" placeholder="Search" (keyup)="onGlobalFilterChange($event)"
				[(ngModel)]="requisitionsContainer.requisitionsQueryFilter.searchText" maxlength="30"
				class="text-center filter-style inputBoxBorder" (ngModelChange)="addToDisplayFilters('search')">
		</div>
		<div class="btn-group pull-right filter-symbol-div-margin pull-right">
			<button class="btn btn-primary" *ngIf="!isCompanyVendor" (click)="uploadRequisition()"
				[disabled]="companyState === 'SoftHold'">Add New Requisition</button>
		</div>
	</div>
</div>

<div class="row" style="position: relative;">
	<div class="col-xs-12 mt-1" id="search-panel" [style.display]="showFiltersPanel ? 'block' : 'none'">
		<div class="main-box" style="padding-top: 1%;">
			<div class="main-box-body clearfix">
				<form role="form" novalidate>
					<div class="row">
						<div class="col-lg-3 col-sm-3 col-md-3">
							<div class="form-group">
								<label for="bu" class="control-label">Belongs To</label>
								<ng-select *ngIf="!loadingClientsOrBUs" [items]="clientsOrBusList" bindLabel="name"
									placeholder="None selected" name="clientsOrBus" id="clients"
									[(ngModel)]="selectedClientsOrBus" [closeOnSelect]="false" [multiple]="true"
									(change)="onClientClick()">
									<ng-template ng-header-tmp>
										<div class="d-flex">
											<div class="mr-2 custom-ng-select-btn" (click)="selectRemoveAll(MESSAGECONSTANTS.LABLES.CLIENT, 'selectAll')">Select All</div>
											<div class="custom-ng-select-btn" (click)="selectRemoveAll(MESSAGECONSTANTS.LABLES.CLIENT, 'removeAll')">Select None</div>
										</div>
									</ng-template>
									<ng-template ng-multi-label-tmp let-items="items">
										<span class="ng-value">
												{{ items[0].name }}<i class="fas fa-share-alt share-icon" *ngIf="items[0].companyType === 'Corporation'"></i>{{ items.length > 1 ? ' ... (' + items.length + ')' : '' }}
											</span>
									</ng-template>
									<ng-template ng-option-tmp let-item="item">
										<span class="share-label">{{ item.name }}</span>
											<i class="fas fa-share-alt" *ngIf="item.companyType === 'Corporation'"></i>
									</ng-template>
								</ng-select>
								<div *ngIf="loadingClientsOrBUs" class="skeleton-loading requisitions-filter-skeleton"></div>
							</div>
						</div>
						<div class="col-lg-3 col-sm-3 col-md-3">
							<div class="form-group">
								<label for="roles" class="control-label">{{ MESSAGECONSTANTS.LABLES.USER_MANAGEMENT.ROLE }}</label>
								<ng-select *ngIf="!loadingRoles" [items]="rolesList" bindLabel="name"
									placeholder="None selected" name="roles" id="roles"
									[(ngModel)]="selectedRoles" [closeOnSelect]="false" [multiple]="true"
									(change)="onRoleClick()">
									<ng-template ng-header-tmp>
										<div class="d-flex">
											<div class="mr-2 custom-ng-select-btn" (click)="selectRemoveAll(MESSAGECONSTANTS.LABLES.USER_MANAGEMENT.ROLE, 'selectAll')">Select All</div>
											<div class="custom-ng-select-btn" (click)="selectRemoveAll(MESSAGECONSTANTS.LABLES.USER_MANAGEMENT.ROLE, 'removeAll')">Select None</div>
										</div>
									</ng-template>
									<ng-template ng-multi-label-tmp let-items="items">
										<span class="ng-value">{{ getMultiSelectSummary(items, 'selectedDisplayName') }}</span>
									</ng-template>
								</ng-select>
								<div *ngIf="loadingRoles" class="skeleton-loading requisitions-filter-skeleton"></div>
							</div>
						</div>
						<div class="col-lg-3 col-sm-3 col-md-3">
							<div class="form-group">
								<label for="requisitionTypes" class="control-label">Requisition Type</label>
								<ng-select [items]="requisitionTypes" bindLabel="name"
									placeholder="None selected" name="requisitionTypes" id="requisitionTypes"
									[(ngModel)]="selectedRequisitionTypes" [closeOnSelect]="false" [multiple]="true"
									(change)="onRequisitionTypeClick()">
									<ng-template ng-header-tmp>
										<div class="d-flex">
											<div class="mr-2 custom-ng-select-btn" (click)="selectRemoveAll('requisitionType', 'selectAll')">Select All</div>
											<div class="custom-ng-select-btn" (click)="selectRemoveAll('requisitionType', 'removeAll')">Select None</div>
										</div>
									</ng-template>
									<ng-template ng-multi-label-tmp let-items="items">
										<span class="ng-value">{{ getMultiSelectSummary(items, 'name') }}</span>
									</ng-template>
								</ng-select>
							</div>
						</div>
						<div class="col-lg-3 col-sm-3 col-md-3">
							<div class="form-group">
								<label for="requisitionStatus" class="control-label">{{ MESSAGECONSTANTS.LABLES.REQUISITION_STATUS }}</label>
								<ng-select *ngIf="!loadingRequisitionStatuses" [items]="statusList" bindLabel="name"
									placeholder="None selected" name="requisitionStatus" id="statuses"
									[(ngModel)]="selectedStatuses" [closeOnSelect]="false" [multiple]="true"
									(change)="onRequisitionStatusClick()">
									<ng-template ng-header-tmp>
										<div class="d-flex">
											<div class="mr-2 custom-ng-select-btn" (click)="selectRemoveAll(MESSAGECONSTANTS.LABLES.REQUISITION_STATUS, 'selectAll')">Select All</div>
											<div class="custom-ng-select-btn" (click)="selectRemoveAll(MESSAGECONSTANTS.LABLES.REQUISITION_STATUS, 'removeAll')">Select None</div>
										</div>
									</ng-template>
									<ng-template ng-multi-label-tmp let-items="items">
										<span class="ng-value">{{ getMultiSelectSummary(items, 'name') }}</span>
									</ng-template>
								</ng-select>
								<div *ngIf="loadingRequisitionStatuses" class="skeleton-loading requisitions-filter-skeleton"></div>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-lg-3 col-sm-3 col-md-3">
							<div class="form-group">
								<label for="requisitionNumbers">{{ MESSAGECONSTANTS.LABLES.REQ_NUMBER }}</label>
								<ng-select *ngIf="!loadingRequisitionNumbers" [items]="requisitionNumbersList" bindLabel="selectedDisplayName"
									placeholder="None selected" name="requisitionNumbers" id="requisitionNumbers"
									[(ngModel)]="selectedRequisitionNumbers" [closeOnSelect]="false" [multiple]="true"
									(search)="onReqNumsSearch($event)" (clear)="getRequisitionNumbers('all')"
									(change)="onRequisitionNumberClick()">
									<ng-template ng-header-tmp>
										<div class="d-flex">
											<div class="mr-2 custom-ng-select-btn" (click)="selectRemoveAll(MESSAGECONSTANTS.LABLES.REQ_NUMBER, 'selectAll')">Select All</div>
											<div class="custom-ng-select-btn" (click)="selectRemoveAll(MESSAGECONSTANTS.LABLES.REQ_NUMBER, 'removeAll')">Select None</div>
										</div>
									</ng-template>
									<ng-template ng-multi-label-tmp let-items="items">
										<span class="ng-value">
											<i [innerHTML]="items[0].icon"></i>{{ items[0].selectedDisplayName }}{{ items.length > 1 ? ' ... (' + items.length + ')' : '' }}
										</span>
									</ng-template>
									<ng-template ng-option-tmp let-item="item">
										<span [innerHTML]="item.icon"></span>{{ item.name }}
									</ng-template>
								</ng-select>
								<div *ngIf="loadingRequisitionNumbers" class="skeleton-loading requisitions-filter-skeleton"></div>
							</div>
						</div>
						<div class="col-lg-3 col-sm-3 col-md-3">
							<div class="form-group">
								<label for="recruiters">
									<span *ngIf="isStaffingCompany">Recruiter/POC</span>
									<span *ngIf="!isStaffingCompany">Recruiter/Hiring Manager</span>
								</label>
								<ng-select *ngIf="!loadingRecruiters" [items]="recruitersList" bindLabel="selectedDisplayName"
									placeholder="None selected" name="recruiters" id="recruiters"
									[(ngModel)]="selectedRecruiters" [closeOnSelect]="false" [multiple]="true"
									(change)="onRecruiterClick()">
									<ng-template ng-header-tmp>
										<div class="d-flex">
											<div class="mr-2 custom-ng-select-btn" (click)="selectRemoveAll(MESSAGECONSTANTS.LABLES.RECRUITER, 'selectAll')">Select All</div>
											<div class="custom-ng-select-btn" (click)="selectRemoveAll(MESSAGECONSTANTS.LABLES.RECRUITER, 'removeAll')">Select None</div>
										</div>
									</ng-template>
									<ng-template ng-multi-label-tmp let-items="items">
										<span class="ng-value" [innerHTML]="getMultiSelectSummary(items, 'selectedDisplayName')"></span>
									</ng-template>
									<ng-template ng-option-tmp let-item="item">
										<span [innerHTML]="item.selectedDisplayName"></span>
									</ng-template>
								</ng-select>
								<div *ngIf="loadingRecruiters" class="skeleton-loading requisitions-filter-skeleton"></div>
							</div>
						</div>
						<div class="col-lg-3 col-sm-3 col-md-3">
							<div class="form-group">
								<label for="jobType" class="control-label">Job Type</label>
								<ng-select [items]="jobTypeList" bindLabel="name"
									placeholder="None selected" name="jobType" id="jobTypes"
									[(ngModel)]="selectedJobTypes" [closeOnSelect]="false" [multiple]="true"
									(change)="onJobTypeClick()">
									<ng-template ng-header-tmp>
										<div class="d-flex">
											<div class="mr-2 custom-ng-select-btn" (click)="selectRemoveAll('Job Type', 'selectAll')">Select All</div>
											<div class="custom-ng-select-btn" (click)="selectRemoveAll('Job Type', 'removeAll')">Select None</div>
										</div>
									</ng-template>
									<ng-template ng-multi-label-tmp let-items="items">
										<span class="ng-value">{{ getMultiSelectSummary(items, 'name') }}</span>
									</ng-template>
								</ng-select>
							</div>
						</div>
						<div class="col-lg-3 col-sm-3 col-md-3">
							<div class="form-group">
								<label for="workLocations" class="control-label">Work Location</label>
								<ng-select *ngIf="!loadingWorkLocations" [items]="workLocationList" bindLabel="name"
									placeholder="None selected" name="workLocations" id="workLocations"
									[(ngModel)]="selectedWorkLocations" [closeOnSelect]="false" [multiple]="true"
									(change)="onWorkLocationClick()">
									<ng-template ng-header-tmp>
										<div class="d-flex">
											<div class="mr-2 custom-ng-select-btn" (click)="selectRemoveAll('Work Location', 'selectAll')">Select All</div>
											<div class="custom-ng-select-btn" (click)="selectRemoveAll('Work Location', 'removeAll')">Select None</div>
										</div>
									</ng-template>
									<ng-template ng-multi-label-tmp let-items="items">
										<span class="ng-value">{{ getMultiSelectSummary(items, 'name') }}</span>
									</ng-template>
								</ng-select>
								<div *ngIf="loadingWorkLocations" class="skeleton-loading requisitions-filter-skeleton"></div>
							</div>
						</div>
						<div class="col-lg-3 col-sm-3 col-md-3">
							<div class="form-group">
								<label for="sortBy">Sort By</label>
								<div class="multiSelect dropdown" id="sortBy">
									<button class="dropdown-toggle form-control access inputBoxBorder" type="button" data-toggle="dropdown">
										<span>{{ selectedSort }}</span>
										<span *ngIf="selectedSort !== 'Please Select' && selectedSortDir === 'Asc'" class="sort-direction">
											<span class="fa fa-arrow-up"></span>
											<span>(Asc)</span>
										</span>
										<span *ngIf="selectedSort !== 'Please Select' && selectedSortDir === 'Desc'" class="sort-direction">
											<span class="fa fa-arrow-down"></span>
											<span>(Desc)</span>
										</span>
										<span class="caret"></span>
									</button>
									<ul class="dropdown-menu dropdown-width">
										<li *ngIf="selectedSort !== 'Please Select'" (click)="sortRequisitions('', 'Please Select', '')">
											<a href="javascript:void(0)">Please Select</a>
										</li>
										<li (click)="sortRequisitions('clientorbu ASC', clientOfBuSortValue, 'Asc')">
											<a href="javascript:void(0)" *ngIf="isClient">{{ clientOfBuSortValue }} (Asc) <span class="fa fa-arrow-up"></span></a>
											<a href="javascript:void(0)" *ngIf="!isClient">{{ clientOfBuSortValue }} (Asc) <span class="fa fa-arrow-up"></span></a>
										</li>
										<li (click)="sortRequisitions('clientorbu DESC', clientOfBuSortValue, 'Desc')">
											<a href="javascript:void(0)" *ngIf="isClient">{{ clientOfBuSortValue }} (Desc) <span class="fa fa-arrow-down"></span></a>
											<a href="javascript:void(0)" *ngIf="!isClient">{{ clientOfBuSortValue }} (Desc) <span class="fa fa-arrow-down"></span></a>
										</li>
										<li (click)="sortRequisitions('requisitionNumber ASC', 'Requisition Number', 'Asc')">
											<a href="javascript:void(0)">Requisition Number (Asc) <span class="fa fa-arrow-up"></span></a>
										</li>
										<li (click)="sortRequisitions('requisitionNumber DESC', 'Requisition Number', 'Desc')">
											<a href="javascript:void(0)">Requisition Number (Desc) <span class="fa fa-arrow-down"></span></a>
										</li>
										<li (click)="sortRequisitions('requisitionState ASC', 'Requisition Status', 'Asc')">
											<a href="javascript:void(0)">Requisition Status (Asc) <span class="fa fa-arrow-up"></span></a>
										</li>
										<li (click)="sortRequisitions('requisitionState DESC', 'Requisition Status', 'Desc')">
											<a href="javascript:void(0)">Requisition Status (Desc) <span class="fa fa-arrow-down"></span></a>
										</li>
										<li (click)="sortRequisitions('title ASC', 'Role', 'Asc')">
											<a href="javascript:void(0)">Role (Asc) <span class="fa fa-arrow-up"></span></a>
										</li>
										<li (click)="sortRequisitions('title DESC', 'Role', 'Desc')">
											<a href="javascript:void(0)">Role (Desc) <span class="fa fa-arrow-down"></span></a>
										</li>
										<li (click)="sortRequisitions('updatedDate ASC', 'Updated Date', 'Asc')">
											<a href="javascript:void(0)">Updated Date (Asc) <span class="fa fa-arrow-up"></span></a>
										</li>
										<li (click)="sortRequisitions('updatedDate DESC', 'Updated Date', 'Desc')">
											<a href="javascript:void(0)">Updated Date (Desc) <span class="fa fa-arrow-down"></span></a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div class="row pull-right">
						<div class="col-lg-12 col-md-12 col-sm-12">
							<div class="form-group" id="searchButton" style="position: relative;">
								<button type="button" class="btn btn-primary mr-2"
									[ngClass]="{'highlight-search-button': isFiltersChanged}"
									(click)="queryRequisitions()"
									[disabled]="loadingClientsOrBUs || loadingRoles || loadingRequisitionStatuses || loadingRequisitionNumbers || loadingRecruiters || loadingWorkLocations">
									<span *ngIf="!requisitionsContainer.loadingSearchButton">Search</span>
									<span *ngIf="requisitionsContainer.loadingSearchButton">
										<span>Searching...</span>
										<span class="fa fa-spinner fa-spin"></span>
									</span>
								</button>
								<button type="reset" class="btn btn-danger" (click)="resetFilterData()">Reset</button>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
<!-- Display Selected Filter Start -->
<div class="row mx-0" *ngIf="displayFilterFlag">
	<div class="main-box mb-0">
		<div class="row my-3 pr-4 mr-1">
			<div class="col-xs-11">
				<div class="text-center pl-5" *ngIf="requisitionsContainer.isFilterOn">
					<span class="badge badge-primary px-3 py-2 ml-5">Filtered Results</span>
				</div>
			</div>
			<div class="col-xs-1">
				<div class="pull-right">
					<span *ngIf="!displayRequisitionSelectedFilter.showDisplayFilterIconFlag" (click)="displaySelectedFilterToggle()">
						<i class="fas fa-plus cursor-pointer" style="font-size: 20px"></i>
					</span>
					<span *ngIf="displayRequisitionSelectedFilter.showDisplayFilterIconFlag" (click)="displaySelectedFilterToggle()">
						<i class="fas fa-minus cursor-pointer" style="font-size: 20px"></i>
					</span>
				</div>
			</div>
		</div>
		<div *ngIf="showDisplaySelectedFilterPanel" id="display-selected-filter-panel" style="background-color: white; padding: 5px 20px 10px;">
			<span *ngFor="let events of displayRequisitionFilterItemsSelected; let parentIndex = index">
				<span *ngIf="isFilterValueArray(events.value)">
					<span *ngFor="let event of (events.value | slice:0:events.setSelectedFilterLimit); let index = index" class="pb-4 d-inline-block">
						<span *ngIf="index === 0">
							<span>( </span>
							<span class="font-bold">{{ events.variable }} = </span>
						</span>
						<span (mouseover)="showFilterDeleteIcon = event" (mouseleave)="showFilterDeleteIcon = null">
							<span class="px-2 py-1 text-black rounded requisition-selected-filter">{{ event }}</span>
							<span class="position-absolute" *ngIf="showFilterDeleteIcon === event">
								<i class="fas fa-times-circle text-danger position-relative cursor-pointer requisition-filter-close-icon"
									(click)="deleteSelectedFilterItem(event)" style="font-size: 13px;"></i>
							</span>
						</span>
						<span *ngIf="events.value.length !== 5 && index === 4 && !events.expandSelectedFilter"
							class="py-1 text-black cursor-pointer"
							(click)="events.setSelectedFilterLimit = events.value.length; events.expandSelectedFilter = true">
							<span title="Expand Filters" class="font-bold pl-2" style="color:#03a9f4;">...</span>
						</span>
						<span *ngIf="!(index === (events.value.length - 1) || index === (events.setSelectedFilterLimit - 1))" class="px-2">OR</span>
						<span *ngIf="index === (events.value.length - 1) || index === (events.setSelectedFilterLimit - 1)">
							<span>)</span>
							<span *ngIf="parentIndex !== (displayRequisitionFilterItemsSelected.length - 1)"> AND</span>
						</span>
					</span>
				</span>
				<span *ngIf="!isFilterValueArray(events.value)" class="pb-4 d-inline-block">
					<span>
						<span>( </span>
						<span class="font-bold">{{ events.variable }} = </span>
					</span>
					<span (mouseover)="showFilterDeleteIcon = events.value" (mouseleave)="showFilterDeleteIcon = null">
						<span class="px-2 py-1 text-black rounded requisition-selected-filter">{{ events.value }}</span>
						<span class="position-absolute" *ngIf="showFilterDeleteIcon === events.value">
							<i class="fas fa-times-circle text-danger position-relative cursor-pointer requisition-filter-close-icon"
								(click)="deleteSelectedFilterItem(events.value)" style="font-size: 13px;"></i>
						</span>
					</span>
					<span> )</span>
					<span *ngIf="displayRequisitionFilterItemsSelected.length > 0">
						<span *ngIf="parentIndex !== (displayRequisitionFilterItemsSelected.length - 1)"> AND</span>
					</span>
				</span>
			</span>
			<span *ngIf="emptySelectedFilter && requisitionsContainer.isFilterOn">
				No Filter Items Selected
			</span>
		</div>
	</div>
</div>
<!-- Display Selected Filter End -->

<div *ngIf="requisitionsContainer.requisitionsExistFlag && !isRowViewActive" class="row animate-if mt-4"
	infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" (scrolled)="requisitionsContainer.getNext()"
	[infiniteScrollDisabled]="requisitionsContainer.busy || requisitionsContainer.disableInfiniteScroll">
	<div [ngClass]="{'col-lg-4 col-md-6 col-sm-6': !isRowViewActive, 'col-xs-12': isRowViewActive}"
		*ngFor="let requisition of requisitionsContainer.requisitions">
		<app-requisition-card [requisitionInfo]="requisition" [activityMap]="activityMap"
			[isRowViewActive]="isRowViewActive" [salaryDurationOptions]="salaryDurationOptions"
			(deleteCallback)="deleteRequisition($event)" (copyCallback)="onRequisitionCopied()"
			[jobTypeList]="jobTypeList">
		</app-requisition-card>
	</div>
</div>
<div class="row" *ngIf="requisitionsContainer.requisitionsExistFlag && !requisitionsContainer.busy && isRowViewActive">
	<div>
		<div style="min-height: 500px">
			<div [ngClass]="{'col-lg-4 col-md-6 col-sm-6': !isRowViewActive, 'col-xs-12': isRowViewActive}"
				*ngFor="let requisition of requisitionsContainer.requisitionsPerPage">
				<app-requisition-card [requisitionInfo]="requisition" [activityMap]="activityMap"
					[isRowViewActive]="isRowViewActive" [salaryDurationOptions]="salaryDurationOptions"
					(deleteCallback)="deleteRequisition($event)" (copyCallback)="onRequisitionCopied()"
					[jobTypeList]="jobTypeList">
				</app-requisition-card>
			</div>
		</div>
		<div class="pull-right pr-2 mr-1">
			<pagination [totalItems]="requisitionsContainer.requisitionCount" [(ngModel)]="currentRequisitionPage"
				[maxSize]="5" [boundaryLinks]="true" [rotate]="false"
				[itemsPerPage]="requisitionsContainer.requisitionsQueryFilter.size"
				(pageChanged)="onRequisitionPageChanged($event)"></pagination>
		</div>
	</div>
</div>
<div class="row" *ngIf="requisitionsContainer.busy">
	<div [ngClass]="{'col-lg-4 col-md-6 col-sm-6': !isRowViewActive, 'col-xs-12': isRowViewActive}"
		*ngFor="let placeholder of skeletonPlaceholders">
		<div *ngIf="!isRowViewActive" class="main-box clearfix project-box emerald-box">
			<div class="main-box-body clearfix" style="height:260px;">
				<div class="p-3 d-flex flex-column justify-content-between skeleton-container" style="height:100%;">
					<div class="d-flex flex-column skeleton-container">
						<div class="skeleton-heading width-75 skeleton-loading my-0 mb-2"></div>
						<div class="skeleton-paragraph width-50 skeleton-loading"></div>
					</div>
					<div class="d-flex justify-content-between skeleton-container">
						<div class="skeleton-paragraph width-25 skeleton-loading"></div>
						<div class="skeleton-paragraph width-25 skeleton-loading"></div>
						<div class="skeleton-paragraph width-25 skeleton-loading"></div>
					</div>
					<div class="d-flex justify-content-between skeleton-container">
						<div class="skeleton-paragraph width-25 skeleton-loading"></div>
						<div class="skeleton-paragraph width-25 skeleton-loading"></div>
						<div class="skeleton-paragraph width-25 skeleton-loading"></div>
					</div>
					<div class="d-flex justify-content-between skeleton-container">
						<div class="skeleton-paragraph width-25 skeleton-loading"></div>
						<div class="skeleton-paragraph width-25 skeleton-loading"></div>
						<div class="skeleton-paragraph width-25 skeleton-loading"></div>
					</div>
					<div class="d-flex justify-content-between align-items-center skeleton-container">
						<div class="skeleton-paragraph width-50 skeleton-loading"></div>
						<div class="skeleton-heading width-25 skeleton-loading my-0"></div>
					</div>
				</div>
			</div>
		</div>
		<div *ngIf="isRowViewActive" class="mb-2">
			<div class="row px-4 py-2 mx-0" style="border:1px solid #e7ebee;border-radius:3px;background:#fff;">
				<div class="w-100 py-2">
					<div class="d-flex flex-column justify-content-between skeleton-container">
						<div class="d-flex flex-column skeleton-container">
							<div class="skeleton-heading width-25 skeleton-loading my-0 mb-3"></div>
							<div class="skeleton-paragraph width-50 skeleton-loading"></div>
						</div>
						<div class="pt-4 skeleton-container d-flex flew-row">
							<div class="d-flex flex-column skeleton-container pr-3" style="width:50%;">
								<div class="skeleton-heading width-25 skeleton-loading my-0 mb-3"></div>
								<div class="skeleton-paragraph width-50 skeleton-loading mb-3"></div>
								<div class="skeleton-paragraph width-75 skeleton-loading mb-3"></div>
								<div class="skeleton-paragraph width-100 skeleton-loading mb-3"></div>
							</div>
							<div class="d-flex flex-column skeleton-container" style="width:50%;">
								<div class="skeleton-heading width-25 skeleton-loading my-0 mb-3"></div>
								<div class="skeleton-paragraph width-50 skeleton-loading mb-3"></div>
								<div class="skeleton-paragraph width-75 skeleton-loading mb-3"></div>
								<div class="skeleton-paragraph width-100 skeleton-loading mb-3"></div>
							</div>
						</div>
						<div class="pb-3 d-flex align-items-center justify-content-end skeleton-container">
							<div class="skeleton-paragraph width-25 skeleton-loading"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="row animate-if" *ngIf="!requisitionsContainer.requisitionsExistFlag">
	<div class="col-xs-12 no_candidates_found text-center d-flex flex-column" style="height: 300px;">
		<span class="my-5" style="font-size: 1.2em;">
			No Requisitions found!
		</span>
		<img src="assets/app-content/img/no_requisitions.svg" style="height:180px" alt="No Candidates Found">
	</div>
</div>
